import React, { useEffect, useState } from 'react';
import { ActivityIndicator } from "react-native"
import type { BestAvailableOrderProps, MarketProps, MarketSideOptionProps, OrderProps, TradeProps } from '../../../types';
import { MarketButtonHelpers } from './api';
import OrderGradeBar from '../OrderGradeBar';
import { Icons } from '../../../Components';
import { Button, Text, View } from '../../../Components/Themed';
import { useColors } from '../../../constants/useColors';

type MarketButtonProps = {
    market:MarketProps,
    side_option:MarketSideOptionProps,
    side_label?:string,
    locked?:boolean,
    highlight_router_orders?:boolean,
    order?:BestAvailableOrderProps,
    trade:TradeProps,
    show_grades?:boolean,
    onPress: (order:OrderProps) => void,
    onLongPress:(trade:TradeProps) => void
}
const MarketCard = ({ side_option, locked, show_grades, market, trade, highlight_router_orders, order, side_label, onPress, onLongPress }:MarketButtonProps) => {
    const C = useColors();
    const [ updated, setUpdated ] = useState<{
        iteration: number,
        iteration_trade?:TradeProps,
        loading:boolean
    }>({
        iteration: 1,
        loading: false
    });
    const { iteration, loading, iteration_trade } = updated;

    const { var_1, odds, color } = MarketButtonHelpers.getButtonLabel(market, side_option, trade, C);
    const handlePress = () => {
        return onPress(MarketButtonHelpers.getOrderFromTrade(trade, undefined, order?.order_id))
    }

    useEffect(() => {
        if(iteration == 1){ return setUpdated({ iteration: 2, loading: false, iteration_trade:trade }) }
        if(JSON.stringify(trade) != JSON.stringify(iteration_trade)){
            setUpdated({ ...updated, loading:true })
            setTimeout(() => {
                setUpdated({ iteration: 2, loading:false, iteration_trade: trade })
            }, 600);
        }
    },[trade])
    return (
        <Button
            style={{ flexGrow:1, padding:0, backgroundColor:color, borderRadius:4, borderColor:C.text.warning, borderTopWidth:highlight_router_orders && order?.router_data?1:0}}
            onPress={() => handlePress()}
            disabled={loading || locked ? true : false}
            onLongPress={() => onLongPress({ ...trade, market:market })}
            >
            <View transparent style={{ flexGrow:1, padding:5, justifyContent:'center'  }}>
                {!market.var_1_required && market.show_side_option ?
                <Text size={12} theme='description' textAlign='center'>{side_label?side_label:side_option.label.toUpperCase()}</Text>
                :<></>}
                {market.var_1_required ?
                <Text size={12} theme='description' textAlign='center'>{var_1}</Text>
                :<></>}
                <Text style={{ marginTop:2 }} theme='description' textAlign='center'>{odds}</Text>
            </View>
            {order ?
                <OrderGradeBar
                    grade={order.grade}
                    view_type='market'
                    mask={!show_grades}
                />
            :<></>}
            {loading ?
            <View type='blur' style={{ position:'absolute', top:0, left:0, right:0, bottom:0, justifyContent:'center', alignItems:'center' }}>
                <ActivityIndicator size='small' color={C.text.highlight} />
            </View>
            :<></>}
            {locked ?
            <View type='blur' style={{ position:'absolute', top:0, left:0, right:0, bottom:0, justifyContent:'center', alignItems:'center', borderRadius:4 }}>
                <Icons.LockClosedIcon size={22} color={C.text.error} />
            </View>
            :<></>}
        </Button>
    )
}

export default React.memo(MarketCard, (left, right) => {
    if(JSON.stringify(left) != JSON.stringify(right)){ return false }
    return true
})